import { useEffect } from "react";
import { PropertiesTestInterface } from "commonModule/services/search";
import DateTooltipMessage from "components/pages/vacation-rentals/TooltipOnSearch/DateTooltipMessage";
import { useAppDispatch } from "stores/hooks";
import { setPriceDropId, setSwitchPriceDrop } from "stores/price-drop/priceDropSlice";

// This component is used to display the price drop alerts section on the desktop/Mobile version of the Search Results page.
const PriceDropsAlertsSection = ({
  propertyData,
  isPolygonSearch,
  mutate
}: {
  propertyData?: PropertiesTestInterface;
  isPolygonSearch: boolean;
  mutate?: () => void;
}) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!propertyData) return;
    const id = propertyData.priceDropAlertId ?? null;
    dispatch(setSwitchPriceDrop(Boolean(id)));
    dispatch(setPriceDropId(id || ""));
  }, [dispatch, propertyData]);
  return <div className='relative' data-sentry-component="PriceDropsAlertsSection" data-sentry-source-file="price-drops-alerts-section.tsx">
      {/* show tooltip message when user arrive from home page and with date search any location then display */}
      <DateTooltipMessage data-sentry-element="DateTooltipMessage" data-sentry-source-file="price-drops-alerts-section.tsx" />
    </div>;
};
export default PriceDropsAlertsSection;